<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from "@/helpers/helper";
import Swal from "sweetalert2";

import { ref } from "vue";

import { useAgentStore } from '@/store/agentStore'
import socket from '@/services/socket'

/**
 * Dashboard Component
 */
export default {

  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const agentStore = useAgentStore();

    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
      agentStore,
    };
  },
  page: {
    title: "agents",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Agents",
      items: [
        {
          text: "Définition",
        },
        {
          text: "Agents",
          active: true,
        },
      ],
      page: 1,
      perPage: 25,
      agents: [],
      search: "",
      status: 201,

      methods: [],
      errors: [],
      agent: {},
      method_id: "",
      account: "",

      capital: 0,
      balance: 0,
      sumDeposit: 0,
      sumWithdraw: 0,
      deposit: 0,
      withdraw: 0,
      receiving: 0,
      sending: 0,
      gain: 0,
      topics: [],
      user: "",

      newTopic: "",
      errors2: {},
      length: 0,
    };
  },
  methods: {
    

     async loadFromStore() {

      if (!this.agentStore.list) {
       await  this.agentStore.loadFromApi(true).then(data => {
        this.agents = data
        this.agent_search = data;
        this.length = this.agents.length;
    })
      } else {
        this.agents = this.agentStore.list
        this.agent_search = this.agents;
                this.length = this.agents.length;

      }

      // Écoute temps réel
      socket.on('agent.created', (data) => {
        this.agentStore.addOne(data)
        this.agents = this.agentStore.list
        this.agent_search = this.agentStore.list;
                this.length = this.agents.length;

      })

      socket.on('agent.updated', (data) => {
        this.agentStore.updateOne(data)
        this.agents = this.agentStore.list
        this.agent_search = this.agentStore.list;
                this.length = this.agents.length;

      })

    },

  async refresh(){
      await  this.agentStore.loadFromApi(true).then(data => {
        this.agents = data
        this.agent_search = data;
        this.length = this.agents.length;
      })
  },



    togglePermission(id) {

      this.doesLoadingOpen = true;

      fetch(Helper.route(`agents/${id}/toggle/subscriptions`), Helper.requestOptionsJSON())
        .then((response) => {
          Helper.tokenChecker(response.status);
          return response.json();
        })
        .then((data) => {

          this.agents_search = data;

          this.agents.push(data);

          this.doesLoadingOpen = false;
        });
    },
    show(index) {
      return (
        index < this.page * this.perPage && index + 1 > (this.page - 1) * this.perPage
      );
    },
    next() {
      if (this.page * this.perPage < this.agents.length) {
        this.page++;
      }
    },
    previous() {
      if (this.page >= 2) {
        this.page--;
      }
    },

     addItem() {
      this.errors = [];
      let body = {
        capital: this.capital,
        balance: this.balance,
        sumDeposit: this.sumDeposit,
        sumWithdraw: this.sumWithdraw,
        deposit: this.deposit,
        withdraw: this.withdraw,
        receiving: this.receiving,
        sending: this.sending,
        gain: this.gain,
        status: this.status,
        topics: this.topics,
        user: {
          id: this.user,
        },
      };
     this.agentStore.createItem(body);
       this.agents = this.agentStore.list
        this.agent_search = this.agents

    },

    editItem() {
      this.errors = [];
      let body = {
        status: this.status,
        topics: this.topics,
        user: {
          id: this.user,
        },
      };

      this.agentStore.editItem(this.agent.id, body);
      this.agents = this.agentStore.list
      this.agent_search = this.agents

     
    },

    loadMethods() {
      fetch(Helper.route("methods"), Helper.requestOptionsJSON())
        .then((response) => {
          Helper.tokenChecker(response.status);
          return response.json();
        })
        .then((data) => {
          this.methods = data;
        });
    },


      compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },

    initItem(agent, action = "edit") {
      this.agent = agent;
      this.initData(agent);
      if (action == "delete") {
        this.doesDeleteOpen = true;
      } else {
        this.doesEditOpen = true;
      }
    },
    initData(item = null) {
      this.capital = item != null ? item.capital : "";
      this.balance = item != null ? item.balance : "";
      this.sumDeposit= item != null ? item.sumDeposit: "";
      this.sumWithdraw= item != null ? item.sumWithdraw: "";
      this.deposit= item != null ? item.deposit: "";
      this.withdraw= item != null ? item.withdraw: "";
      this.receiving= item != null ? item.receiving: "";
      this.sending= item != null ? item.sending: "";
      this.gain= item != null ? item.gain: "";
      this.status= item != null ? item.status: "";
      this.topics = item != null ? (item.topics ?? []) : [];
      this.user = item != null ? item.user?.id : "";
    },

    addTopic() {
      if (this.newTopic.trim() === "") {
        this.errors2.topics = "Veuillez entrer un topic.";
        return;
      }

      this.topics.push(this.newTopic.trim());
      this.newTopic = ""; // Réinitialiser le champ d'entrée
      this.errors2.topics = ""; // Effacer les erreurs
    },
    // Supprimer un topic de la liste
    removeTopic(index) {
      this.topics.splice(index, 1);
    },

    validateTopic() {
      // Exemple de validation avant soumission
      if (this.topics.length === 0) {
        this.errors2.topics = "Veuillez ajouter au moins un topic.";
        return;
      }
      // Votre logique de soumission ici...
    },
  },
  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
      <b-button variant="primary" @click="doesEditOpen = true" class="ms-auto">
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        Ajouter un nouveau
      </b-button>
    </div>
    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des Agents</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>Agents</code>.
            </p>

            <div class="row mb-4">
              <div class="col-md-3">
                <input
                  type="search"
                  class="form-control"
                  v-model="search"
                  v-on:input="filter_agent()"
                  placeholder="Rechercher une personne"
                />
              </div>
              <div class="col-2 ms-auto">
                <select v-model="perPage" class="form-control text-center">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                </select>
              </div>

              <div class="ms-2 col-3 ps-5 hstack">
                <i
                  class="bx bx-left-arrow-alt p-2 fs-5"
                  type="button"
                  @click="previous"
                ></i>

                <small class="ms-3">
                  {{ Math.ceil(agents.length / perPage) > 0 ? page : 0 }} /
                  {{ Math.ceil(agents.length / perPage) }}
                </small>

                <i
                  class="bx bx-right-arrow-alt fs-5 p-2 ms-3"
                  type="button"
                  @click="next"
                ></i>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr class="bg-light">
                    <th>#</th>
                    <th>User</th>
                    <th>Email</th>
                    <th>Status</th>
                    <th>Roles</th>
                    <th>Notis</th>
                    <th class="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(agent, index) in agents"
                    v-show="show(index)"
                    :key="agent.id"
                  >
                    <th scope="row"  v-on:click="compileToClipboard(agent.id)"
                      style="cursor: pointer">
                      {{ index + 1 + (page - 1) * perPage }}
                    </th>
                    <td>
                      <img
                        :src="agent?.user?.profile"
                        :alt="agent?.user?.lastName"
                        style="height: 35px; width: 35px"
                        class="border rounded-circle"
                      />
                      {{ agent?.user?.firstName }} {{ agent?.user?.lastName }}
                    </td>
                    <td>{{ agent?.user?.email }}</td>
                    <td>
                      <button
                        class="badge badge-pill badge-soft-success border-0 py-1 w-100"
                        v-if="agent.status == 'active'"> {{agent.status}} </button>
                      <button
                        class="badge badge-pill badge-soft-danger border-0 py-1 w-100"
                        v-else
                      >
                        {{ agent.status }}
                      </button>
                    </td>

                    <td>{{ agent?.topics?.join(" ") }}</td>

                    

                    <td>
                      <button
                        class="badge badge-pill badge-soft-success border-0 py-1 w-100"
                        @click="togglePermission(agent.id)"
                        variant="danger"
                        > {{agent.subscribe}} </button>
                    </td>

                    <td class="hstack">
                      <b-button
                        class="btn-sm ms-2"
                        @click="initItem(agent, 'edit')"
                        variant="success"
                      >
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <router-link :to="'/agents/' + agent.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                      
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- EDIT MODAL -->
    <b-modal
      v-model="doesEditOpen"
      id="modal-center"
      centered
      scrollable
      size="lg"
      title="Modifier un aggregateur méthode"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="editItem()">
        <div class="row">

          <div class="col-md-6 mb-3">
            <label for="">gain</label>
            <input type="text" required v-model="gain" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.gain">{{ errors.gain }}</span>
          </div>

          <div class="col-md-6 mb-3">
            <label for="">Status</label>
            <select required v-model="status" class="form-control">
              <option value="active">active</option>
              <option value="unverified">unverified</option>
              <option value="disabled">disabled</option>
              <option value="blocked">blocked</option>
              <option value="deleted">deleted</option>
            </select>
            <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
          </div>

          <!-- <div class="col-md-6 mb-3">
              <label for="">topics</label>
              <input type="text" required v-model="topics" class="form-control">
              <span class="text-danger mt-2" v-if="errors.topics">{{ errors.topics }}</span>
            </div> -->

          <div class="col-md-12 mb-3">
            <label for="">user</label>
            <input type="text" required v-model="user" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.user">{{ errors.user }}</span>
          </div>

           <div class="col-md-12 mb-3">
            <label for="">Topics</label>
            <div class="input-group mb-2">
              <input
                type="text"
                v-model="newTopic"
                class="form-control"
                placeholder="Ajouter un topic"
              />
              <button type="button" class="btn btn-secondary" @click="addTopic">
                Ajouter
              </button>
            </div>
            <ul class="list-group">
              <li
                v-for="(topic, index) in topics"
                :key="index"
                class="list-group-item d-flex justify-content-between align-items-center"
              >
                {{ topic }}
                <button
                  type="button"
                  class="btn btn-danger btn-sm"
                  @click="removeTopic(index)"
                >
                  Supprimer
                </button>
              </li>
            </ul>
            <span class="text-danger mt-2" v-if="errors2.topics">{{
              errors2.topics
            }}</span>
          </div>


        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
